import React from "react";
import PropTypes from "prop-types";
import { withState } from "react-searchkit";
import history from "@history";
import ClearButton from "./ClearButton";

const ClearFiltersButton = ({
  currentQueryState,
  updateQueryState,
  moduleIdentifier = "documents", // Default value if not provided
}) => {
  // Page-specific storage key
  const FILTER_STORAGE_KEY = `filters-${moduleIdentifier}`;

  const hasFilters =
    Array.isArray(currentQueryState.filters) &&
    currentQueryState.filters.length > 0;

  const handleClick = (e) => {
    e.currentTarget.blur(); // Lose button focus

    // Clear URL and resets internal query
    history.replace({ pathname: history.location.pathname, search: "" });

    // Clear filters from session storage using the page-specific key
    sessionStorage.removeItem(FILTER_STORAGE_KEY);

    // Set filters to an empty array
    updateQueryState({ ...currentQueryState, filters: [] });
  };

  return (
    <ClearButton
      clickHandler={handleClick}
      text="Clear Filters"
      disabled={!hasFilters}
    />
  );
};

ClearFiltersButton.propTypes = {
  currentQueryState: PropTypes.object.isRequired,
  updateQueryState: PropTypes.func.isRequired,
  moduleIdentifier: PropTypes.string, // New prop to identify the page
};

export default withState(ClearFiltersButton, { queryState: "queryState" });
